module.exports = {
      id: "design-usage",
      viewBox: "0 0 353.6 345.02",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#design-usage",
      toString: function () {
        return this.url;
      }
    }